import {call, put, takeLeading} from 'redux-saga/effects';
import {AsyncResult} from 'Core/models/Async';
import {isRight} from 'fp-ts/lib/Either';
import {
  changeTaxYears,
  changeTaxYearsLoading,
  TaxYearsActionType,
} from 'Core/ducks/taxYears';
import taxportYearApi from 'Core/api/taxportYearApi';

function* fetchTaxYearsFromApi(action) {
  try {
    yield put(changeTaxYearsLoading(true));

    const response: AsyncResult<string[]> = 
              yield call(taxportYearApi.getTaxYears, action.payload);

    if (isRight(response)) {
      const years = response.right.reduce<string[]>((allYears, value) => {
        const parsedYears = value
          .split(',')
          .map(year => year.trim())
          .filter(Boolean);
        return allYears.concat(parsedYears);
      }, []);

      yield put(changeTaxYears(years));
    } else {
      yield put(changeTaxYears([]));
    }
  } catch {
    yield put(changeTaxYears([]));
  } finally {
    yield put(changeTaxYearsLoading(false));
  }
}

export default function* taxYearsSaga() {
  yield takeLeading(TaxYearsActionType.FETCH_TAX_YEARS, fetchTaxYearsFromApi);
}